export class SvgInjector {
	init(){
		var mySVGsToInject = document.querySelectorAll('img.inject-svg');
		SVGInjector(mySVGsToInject, {}, function(){
			
		});
	}
}